module.exports = __webpack_public_path__ + "static/img/far2_active.ac3cb41b.png";